import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { STAKEHOLDER_ROLES_V2, STAKEHOLDER_TYPES } from '@/containers/withStakeholderLogic';
import { getStakeholders } from '@/selectors/merchant/recollection';

// Stakeholders to render in the selector
export const getDefaultState = createSelector(getStakeholders, stakeholders => ({
  stakeholders: mapStakeholder(
    stakeholders.filter(
      s =>
        (s.roles.includes(STAKEHOLDER_ROLES_V2.APPLICANT) && s.roles.length > 1) ||
        !s.roles.includes(STAKEHOLDER_ROLES_V2.APPLICANT),
    ),
  ),
}));

// Applicants with multiple roles
export const getSubmittedApplicantIds = createSelector(getStakeholders, stakeholders => {
  return stakeholders
    .filter(s => s.roles.includes(STAKEHOLDER_ROLES_V2.APPLICANT) && s.roles.length > 1)
    .map(stakeholder => stakeholder.id);
});

const mapStakeholder = stakeholders =>
  stakeholders.map(stakeholder => {
    const dateOfBirth = _get(stakeholder, 'data.dateOfBirth', null);
    const region = _get(stakeholder, 'data.address.region', '');

    return {
      ...stakeholder,
      dateOfBirth,
      ...stakeholder.data,
      address: {
        region,
        ...stakeholder.data.address,
      },
      type: STAKEHOLDER_TYPES.PERSON,
    };
  });
